import {
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Typography,
    Button,
} from "@material-tailwind/react";
import { BiSolidTimeFive } from "react-icons/bi";
import { BsFillQuestionCircleFill } from "react-icons/bs";
import { GoNumber } from "react-icons/go";


const NewTestCard = ({ name = "Test Name", duration = "-", totalQ = "Not Known", totalM = "Not Known",test, callback, disabled=false }) => {
    return (
        <Card variant="gradient" className="w-full max-w-[20rem] p-3 py-5 h-max m-3 bg-bgBlue text-white">
            <CardHeader
                floated={false}
                className="m-0 mb-5 bg-bgBlue border-2 border-white/10 text-center rounded"
            >
                <Typography
                    variant="h4"
                    color="white"
                    className="mt-3 flex justify-center gap-1 text-2xl font-normal"
                >
                    {name}
                </Typography>
            </CardHeader>
            <CardBody className="p-0">
                <ul className="flex flex-col gap-2">
                    <li className="flex items-center align-middle gap-4 border-b-2 border-[#ffffff8a]">
                        <span className="rounded-full border border-white/20 bg-white/20">
                            <BiSolidTimeFive className="h-5 w-5" />
                        </span>
                        <Typography className="font-normal my-1">{duration} Minutes</Typography>
                    </li>


                    <li className="flex items-center align-middle gap-4 border-b-2 border-[#ffffff8a]">
                        <span className="rounded-full border border-white/20 bg-white/20 ">
                            <BsFillQuestionCircleFill className="h-5 w-5" />
                        </span>
                        <Typography className="font-normal my-1">Questions : { totalQ}</Typography>
                    </li>


                    <li className="flex items-center align-middle gap-4 border-b-2 border-[#ffffff8a]">
                        <span className="rounded border border-white/20 bg-white/20 ">
                            <GoNumber  className="h-5 w-5" />
                        </span>
                        <Typography className="font-normal my-1">Marks : {totalM}</Typography>
                    </li>
                </ul>
            </CardBody>
            <CardFooter className="p-0 flex justify-center m-3">
                <Button
                    size="lg"
                    color="white"
                    className="text-bgBlueDark hover:scale-[1.02] focus:scale-[1.02] active:scale-100"
                    onClick={()=>{callback(test)}}
                    disabled={disabled}
                >
                    Attempt Now
                </Button>
            </CardFooter>
        </Card>
    );
}

export default NewTestCard;